<div class="module-wrapper content-wrapper" *ngIf="roleSer.accessData && (roleSer.accessData.viewAllowed || roleSer.accessData.insertAllowed)">
  <mat-card>
    <mat-card-content>
      <div class="head-container">
        <h1>{{'users.heading' | translate}}</h1>
        <!-- <div (mouseover)="onTraningIcon(videoAssetGroups.UserTraining)">
          <img class="trainingIcon" src="../../../assets/favicon/video.png">
        </div>
        <div class="popupHover">
          <ng-container *ngIf="isHidden">
            <div class="hideshow">
              <a *ngFor="let links of videoLinks" (click)="open_in_new_window('location=1,status=1,toolbar=1,resizeable=1,width=350,height=300', links.assetUrl);">{{links.assetShortName}} <br></a>
            </div>
          </ng-container>
        </div> -->
      </div>

      <div class="itemBtn">
        <span class="spacer"></span>
        <div>
          <div class="btn-wrapper">
            <button mat-flat-button color="" class="btn-warn" aria-label="Add New Item" (click)="openNewUserDialog()"
              [disabled]="roleSer.accessData?!roleSer.accessData.insertAllowed :true"> + {{'users.btnNew' | translate}}</button>
          </div>
        </div>
      </div>

      <div class="input-container">
        <div class="input-fields-wrapper">
          <div class="input-wrapper">
            <input type="text" [(ngModel)]='firstName' placeholder="{{'users.labelFname' | translate}}" class="form-control ng-untouched ng-pristine ng-valid"
              ng-reflect-model="" filterValidator="Name">
            <input type="text" [(ngModel)]='lastName' placeholder="{{'users.labelLname' | translate}}" class="form-control ng-untouched ng-pristine ng-valid"
              ng-reflect-model="" filterValidator="Name">
            <input type="text" [(ngModel)]='emailId' placeholder="{{'users.labelEmail' | translate}}" class="form-control ng-untouched ng-pristine ng-valid"
              ng-reflect-model="" filterValidator="Email">
            <!-- <select aria-placeholder="Status" [(ngModel)]='userStatus' class="form-control ng-untouched ng-pristine ng-valid" ng-reflect-model="">
                            <option value="" ng-reflect-value="">Status</option>
                            <option value="true" ng-reflect-value="">Active</option>
                            <option value="false" ng-reflect-value="">Inactive</option>
                        </select> -->

            <select aria-placeholder="Status" [(ngModel)]="userStatus" class="form-control ng-untouched ng-pristine ng-valid" ng-reflect-model="">
              <option value="">{{'users.labelStatus' | translate}}</option>
              <option *ngFor="let statusList of statusList" value="{{ statusList.title }}">
                {{ statusList.title }}
              </option>
              <!-- <option value="" ng-reflect-value="">Status</option>
                          <option value="Published" ng-reflect-value="Published">Published</option>
                          <option value="Unpublished" ng-reflect-value="Unpublished">Unpublished</option> -->
            </select>
            <!-- <select [(ngModel)]='userStatus'>
                            <option value="" value="">Status</option>
                            <option value="true" value="" selected>Active</option>
                            <option value="false" value="">Inactive</option>
                        </select> -->

          </div>
          <div class="btn-wrapper">
            <button mat-flat-button color="" class="btn-primary" aria-label="Search" (click)='userFilter()'>{{'users.btnSearch' | translate}}</button>
            <button mat-flat-button color="" class="btn-flat" aria-label="Reset" (click)='resetFilter()'>
              {{'users.btnReset' | translate}}
            </button>
          </div>
        </div>
      </div>
      <div *ngIf="isNoUser" class="data-not-found-container table-container">
        <span>{{'users.noUserMsg' | translate}}</span>
      </div>
      <div *ngIf="!isNoUser && !noDataFound">
        <div class="table-container">
          <table mat-table [dataSource]="usersData" class="mat-elevation-z8">

            <ng-container matColumnDef="firstName">
              <th mat-header-cell *matHeaderCellDef [resizeColumn]="true">{{'users.column1' | translate}}</th>
              <td mat-cell *matCellDef="let row">
                {{row?.firstName}}
              </td>
            </ng-container>
            <ng-container matColumnDef="lastName">
              <th mat-header-cell *matHeaderCellDef [resizeColumn]="true">{{'users.column2' | translate}} </th>
              <td mat-cell *matCellDef="let row">
                {{row.lastName}}
              </td>
            </ng-container>
            <ng-container matColumnDef="emailId">
              <th mat-header-cell *matHeaderCellDef [resizeColumn]="true">{{'users.column3' | translate}} </th>
              <td mat-cell *matCellDef="let row">
                <ng-container *ngIf="row.emailId.length > 40 then sliceEmail else noSliceEmail">
                </ng-container>
                <ng-template #sliceEmail>
              <td matTooltip="{{row?.emailId}}" matTooltipPosition="above" innerHtml="{{row?.emailId | slice:0:40}}..." class="itemrow">
              </td>
              </ng-template>
              <ng-template #noSliceEmail>
                <td class="itemrow">{{row.emailId}}</td>
              </ng-template>
              </td>
            </ng-container>
            <ng-container matColumnDef="roles">
              <th mat-header-cell *matHeaderCellDef [resizeColumn]="true" style="width: 45% !important;">{{'users.column4' | translate}}</th>
              <td mat-cell *matCellDef="let row">
                <div class="demo">
                  <div *ngFor="let data of row.collectionWithRoles; let i=index" class="collections">

                      <ng-container *ngIf="data.collectionname?.length > 40 then sliceTitle else noSliceTitle">
                      </ng-container>

                      <ng-template #sliceTitle>
                        <div class="text-bold" matTooltipClass="my-custom-tooltip" matTooltip="{{data.collectionname}}" matTooltipPosition="above">
                          <b>{{data.collectionname | slice: 0:40}}... <span class="roleSpan">:</span></b></div>
                      </ng-template>
                      <ng-template #noSliceTitle>
                        <div class="text-bold"><b>{{data.collectionname }} <span class="roleSpan">:</span></b></div>
                      </ng-template>

                    <ng-container *ngIf="data.roles.length > 0">
                      <span *ngFor="let a of data.roles; let i=index" class="roless">
                        <ng-container *ngIf="a.rolename?.length > 40 then sliceTitle else noSliceTitle">
                        </ng-container>

                        <ng-template #sliceTitle>
                          <div class="text-bold" matTooltipClass="my-custom-tooltip" matTooltip="{{a.rolename}}" matTooltipPosition="above">
                            {{a.rolename | slice: 0:40}}...</div>
                        </ng-template>
                        <ng-template #noSliceTitle>
                          <div class="text-bold">{{a.rolename}}</div>
                        </ng-template>
                        <span class="roleSpan" *ngIf="i !== data.roles.length - 1">, </span>
                      </span>
                    </ng-container>
                  </div>
                </div>
              </td>
            </ng-container>
            <ng-container matColumnDef="status">
              <th mat-header-cell *matHeaderCellDef [resizeColumn]="true">{{'users.column5' | translate}}</th>
              <td mat-cell *matCellDef="let row">
                <!--  <i *ngIf="row?.active === true"  class="fa fas fa-circle publish"
                                matTooltip="Active"
                                matTooltipPosition="above">
                             </i>-->
                <span *ngIf="row?.active === true" class="fa fas fa-circle publish" matTooltip="{{'users.statusTooltip.active' | translate}}" matTooltipPosition="above">
                </span>
                <span *ngIf="row?.active === false" class="glyphicon glyphicon-adjust unpublish" matTooltip="{{'users.statusTooltip.inactive' | translate}}" matTooltipPosition="above">
                </span>
              </td>
            </ng-container>
            <ng-container matColumnDef="updated">
              <th mat-header-cell *matHeaderCellDef [resizeColumn]="true">{{'users.column6' | translate}}</th>
              <td mat-cell *matCellDef="let row">
                <div class="text-bold"> {{row.modifiedByUser}} </div>
                <div> {{ row.modifiedDateTime | dateAgo }} </div>

              </td>
            </ng-container>
            <!-- <ng-container matColumnDef="action">
                            <th mat-header-cell *matHeaderCellDef [resizeColumn]="true"> Action</th>
                            <td mat-cell *matCellDef="let row"> -->
            <!-- <button mat-icon-button [matMenuTriggerFor]="menu" aria-label="Example icon-button with a menu"> -->
            <!-- <mat-icon>more_vert</mat-icon> -->
            <!-- </button> -->
            <!-- <mat-menu #menu="matMenu">
                                    <button mat-menu-item (click)='openEditUserDialog(row.useruuid)'>
                                        <mat-icon>edit</mat-icon>
                                        <span>Edit</span>
                                    </button>
                                </mat-menu>
                            </td>
                        </ng-container> -->
            <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky:true"></tr>
            <tr class="pointer" mat-row *matRowDef="let row; columns: displayedColumns;"
              (click)="(roleSer.accessData?!roleSer.accessData.updateAllowed :true) ? '' : openEditUserDialog(row.useruuid)"></tr>
          </table>
        </div>
        <div class="user-pagination" *ngIf="usersData.data.length > 0">
          <mat-paginator [pageSizeOptions]="[10, 50, 100]" showFirstLastButtons></mat-paginator>
        </div>
      </div>
      <div class="data-not-found-container" *ngIf='noDataFound'>
        <p>{{'users.errorMsg' | translate}}</p>
      </div>
    </mat-card-content>
  </mat-card>
</div>


<!-- <div class="users-container main-content-wrapper">
    <div class="content-wrapper">
        <div class="filter-section">
            <div class="container-fluid">
                <div class="row">
                    <div class="col-md-10">
                        <div class="input-fields-wrapper">
                            <div class="input-wrapper">
                                <input type="text" class="form-control" [(ngModel)]='firstName' placeholder="First name">
                                <input type="text" class="form-control" [(ngModel)]='lastName'  placeholder="Last name">
                                <input type="text" class="form-control" [(ngModel)]='emailId'  placeholder="Email">
                                    <select aria-placeholder="Status" class="form-control" [(ngModel)]='userStatus'>
                                        <option value="">Status</option>
                                        <option value="true">Active</option>
                                        <option value="false">Inactive</option>
                                    </select>
                            </div>
                            <div class="btn-wrapper">
                                <button (click)='userFilter()' class="btn-bg-color" mat-raised-button>
                                    <span>Search</span>
                                </button>
                                <button class="btn-green-text" (click)='resetFilter()' mat-raised-button>
                                    <span>Reset</span>
                                </button>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-2">
                        <div class="btn-wrapper">
                            <button (click)='createNewUser()' class="btn-orange"  mat-flat-button>
                                <span> + New User</span>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>


        <div class="container-fluid">
                 <div *ngIf="isNoUser" class="data-not-found-container table-container">
                     <span>No Users for this client</span>
                </div>
            <div *ngIf="!isNoUser" class="row">
                <div class="col-md-12">
                    <div class="table-container">
                        <table mat-table [dataSource]="usersData" matSort class="mat-elevation-z8">
                            <ng-container matColumnDef="firstName">
                                <th mat-header-cell *matHeaderCellDef >First name</th>
                                <td mat-cell *matCellDef="let row" (click)='navigateToUserDetails(row.useruuid)'>
                                 {{row?.firstName}}
                                </td>
                            </ng-container>
                            <ng-container matColumnDef="lastName">
                                <th mat-header-cell *matHeaderCellDef>Last name </th>
                                <td mat-cell *matCellDef="let row" (click)='navigateToUserDetails(row.useruuid)'>{{row.lastName}}</td>
                            </ng-container>
                            <ng-container matColumnDef="emailId">
                                <th mat-header-cell *matHeaderCellDef>Email </th>
                                <td mat-cell *matCellDef="let row"(click)='navigateToUserDetails(row.useruuid)'>
                                    <ng-container *ngIf="row.emailId.length > 30 then sliceEmail else noSliceEmail"></ng-container>
                                    <ng-template #sliceEmail>
                                      <td matTooltip="{{row?.emailId}}" matTooltipPosition="above" innerHtml="{{row?.emailId | slice:0:15}}">...
                                      </td>
                                    </ng-template>
                                    <ng-template #noSliceEmail>
                                     <td>{{row.emailId}}</td>
                                    </ng-template>
                                </td>
                            </ng-container>
                            <ng-container matColumnDef="status">
                                <th mat-header-cell *matHeaderCellDef>Status</th>
                                <td mat-cell *matCellDef="let row" (click)='navigateToUserDetails(row.useruuid)'>
                                    <i *ngIf="row?.active === true" class="fa fas fa-circle publish"
                                    matTooltip="Active"
                                    matTooltipPosition="right"></i>
                                    <span *ngIf="row?.active === false" class="glyphicon glyphicon-adjust unpublish"
                                    matTooltip="Inactive"
                                    matTooltipPosition="right"></span>
                                </td>
                            </ng-container>
                            <ng-container matColumnDef="updated">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header>Updated</th>
                                <td mat-cell *matCellDef="let row" (click)='navigateToUserDetails(row.useruuid)'>
                                    <span class="text-bold"> {{row.modifiedByUser}} </span>
                                     <br> {{ row.modifiedDateTime | dateAgo }}

                                </td>
                            </ng-container>
                            <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky:true"></tr>
                            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                        </table>
                        <div class="data-not-found-container" *ngIf='noDataFound'>
                            <p>Data not found</p>
                        </div>
                    </div>
                    <div class="user-pagination">
                        <mat-paginator #paginator [pageSizeOptions]="[10, 50, 100]"></mat-paginator>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>  -->
